// src/pages/PrivacyPolicy.jsx
import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        my: 4,
        px: { xs: 2, sm: '5vw', md: '7vw' },
      }}
    >
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main' }}>
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" sx={{ color: 'text.secondary', mt: 1 }}>
          Last updated: August 1, 2026
        </Typography>
      </Box>

      <Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Gupta Decor (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) operates the website and online store at
          guptadecoration.com. This Privacy Policy explains what personal information we collect,
          how we use it, and your choices regarding that information.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          Information We Collect
        </Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          When you create an account or shop with us, we may collect:
        </Typography>
        <Typography component="ul" variant="body1" sx={{ pl: 3, mb: 2 }}>
          <li>Account details: name, email address, and password (stored in hashed form)</li>
          <li>Contact and shipping details: phone number, address, city, state, ZIP/postal code, and country</li>
          <li>Order and cart data needed to process and fulfill your purchases</li>
          <li>Technical session data such as authentication tokens (JWT) used to keep you signed in</li>
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          How We Use Your Information
        </Typography>
        <Typography component="ul" variant="body1" sx={{ pl: 3, mb: 2 }}>
          <li>To create and manage your account</li>
          <li>To process orders, manage your cart, and provide customer support</li>
          <li>To send transactional emails such as password reset and order-related messages</li>
          <li>To operate, secure, and improve our website and services</li>
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          Product Images and Hosting
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Product images displayed on our store are hosted via Cloudinary for content delivery.
          Customers do not upload personal photos through the storefront as part of normal use.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          Third-Party Login
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Our store currently uses email and password authentication. We do not require Facebook
          Login to use the website. If we enable social login features in the future, this policy
          will be updated accordingly.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          Data Retention
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          We retain account and order information for as long as needed to provide our services and
          meet legal, tax, or accounting requirements. You may request deletion of your personal
          data as described on our{' '}
          <Link href="/data-deletion" underline="hover">
            Data Deletion
          </Link>{' '}
          page.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          Your Rights
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          You may request access to, correction of, or deletion of your personal information by
          contacting us. We will respond to verified requests within a reasonable timeframe.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mt: 3, mb: 1 }}>
          Contact Us
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          For privacy-related questions or requests, email{' '}
          <Link href="mailto:nilesh@guptadecoration.com" underline="hover">
            nilesh@guptadecoration.com
          </Link>
          .
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
